import { render, staticRenderFns } from "./CLike.vue?vue&type=template&id=0e87597c&"
import script from "./CLike.vue?vue&type=script&lang=ts&"
export * from "./CLike.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports